module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "查看相关设备情况",
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "innerTitle"
  }, [_vm._v("\n               查看相关设备情况\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box2"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("已下单4000设备数：" + _vm._s(_vm.form.PassServiceRoomNum))]), _vm._v(" "), _c('p', [_vm._v("未抵扣样机数：" + _vm._s(_vm.form.NoProtoTypeNum))])]), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("已绑定园所设备数：" + _vm._s(_vm.form.HardBindNum))]), _vm._v(" "), _c('p', [_vm._v("Hi-A设备数：" + _vm._s(_vm.form.HiAServiceEquipNum))])])]), _vm._v(" "), _c('div', {
    staticClass: "inner",
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "border-top": "none"
    }
  }, [_c('p', [_vm._v("智趣坞55寸设备数：" + _vm._s(_vm.form.Book55TvTotalNum)), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(包含后台下单的智趣坞独家设备)")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3800b7e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Agent/hiPackage/components/deviceView/index.vue
// module id = 1453
// module chunks = 1